import React from 'react';
import { Outlet } from 'react-router-dom';

const SessionsHome = () => (
  <section className="app-route">
    <Outlet />
  </section>
);

export default SessionsHome;
